import { FC } from 'react';
import { BookOpen } from 'lucide-react';

interface CourseEmptyStateProps {
  title?: string;
  description?: string;
}

export const CourseEmptyState: FC<CourseEmptyStateProps> = ({
  title = 'No courses enrolled yet',
  description = 'This student is not enrolled in any courses yet. Add a course to start tracking their progress.',
}) => {
  return (
    <div className="flex min-h-[60vh] flex-1 flex-col items-center justify-start gap-4 rounded-xl border border-(--neutral-black-NB200) pt-16 text-center">
      <div className="flex size-14 items-center justify-center rounded-full bg-(--primary-O200)">
        <BookOpen className="size-7 text-(--primary-O900)" />
      </div>

      <div className="flex max-w-90 flex-col gap-2">
        <h4 className="[font-family:var(--font-arvo)] [font-size:var(--fs-h5)] m-0! font-bold text-(--neutral-black-NB1000)!">
          {title}
        </h4>

        <p className="[font-size:var(--fs-p3)] m-0! text-(--neutral-black-NB700)">{description}</p>
      </div>
    </div>
  );
};
